module.exports = __webpack_public_path__ + "img/wedding-moment.f88c5da2.webp";